import './styles.scss';
import React from 'react';
import classnames from 'classnames';
import { TsrSvgIcon, Icon } from 'tacho-ui';

interface TabDropdownItemProps {
    label: string;
    isActive: boolean;
    isClosable?: boolean;
    isUpperCase?: boolean;
    isResetable?: boolean;
    onClick: () => void;
    onResetDefault: () => void;
    onClose: () => void;
}

export class TabDropdownItemComponent extends React.Component<TabDropdownItemProps> {
    public render(): JSX.Element {
        const navItemCloseClassName = this.props.isActive ? 'navItemClose' : '';
        return (
            <div
                className={classnames(
                    { activeTab: this.props.isActive },
                    { inactiveTab: !this.props.isActive },
                    'navTabDropdownItem',
                )}
            >
                <button type="button" className="dropdown-item" onClick={(): void => this.props.onClick()}>
                    {this.props.isUpperCase ? this.props.label.toUpperCase() : this.props.label}
                </button>
                {this.props.isClosable && (
                    <TsrSvgIcon
                        pointer
                        icon={Icon.Close}
                        className={navItemCloseClassName}
                        onClick={() => this.props.onClose()}
                    />
                )}
                {this.props.isResetable && (
                    <TsrSvgIcon
                        className={navItemCloseClassName}
                        icon={Icon.Refresh}
                        onClick={() => this.props.onResetDefault()}
                        pointer
                    />
                )}
            </div>
        );
    }
}
